import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-keyboard",
  "use": "icon-m-keyboard-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-keyboard\"><path d=\"M37.098 10c.495 0 .902.507.902 1.125v17.748c0 .62-.407 1.127-.902 1.127H3.902C3.407 30 3 29.493 3 28.873V11.125c0-.618.407-1.125.902-1.125Zm-.765 1.667H4.667v16.666h31.666zM30 25v2H12v-2zm0-7v4h-4v-4zm5 0v4h-4v-4zm-25 0v4H6v-4zm5 0v4h-4v-4zm5 0v4h-4v-4zm5 0v4h-4v-4zm-15-5v4H6v-4zm5 0v4h-4v-4zm5 0v4h-4v-4zm5 0v4h-4v-4zm5 0v4h-4v-4zm5 0v4h-4v-4z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol